module.exports = __webpack_public_path__ + "static/monikawork6-8bb18a88f9835c679b96f06d2db41242.jpg";